import axios from 'axios';

const getBaseURL = (env) => {
  switch (env) {
    case 'stage':
      return process.env.REACT_APP_STAGE_URL;
    case 'production':
      return process.env.REACT_APP_PROD_URL;
    default:
      return process.env.REACT_APP_STAGE_URL;
  }
};

const getChatBotBaseURL = (env) => {
  switch (env) {
    case 'stage':
      return process.env.REACT_APP_PUBLIC_CHATBOT_URL;
    case 'production':
      return process.env.REACT_APP_PROD_PUBLIC_CHATBOT_URL;
    default:
      return process.env.REACT_APP_PUBLIC_CHATBOT_URL;
  }
};

const client = axios.create({
  baseURL: getBaseURL(process.env.REACT_APP_ENV),
});

export const publicChatBotClient = axios.create({
  baseURL: getChatBotBaseURL(process.env.REACT_APP_ENV),
});

client.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

publicChatBotClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

publicChatBotClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default client;
